import { makeStateKey } from '@angular/core';

export const API_URL_STATE = makeStateKey<string>('api-url');
export const TURNSTILE_KEY_STATE = makeStateKey<string>('turnstile-key');
